import { useState } from "react";
import { Button, Form, type FormProps, Input } from "antd";
import { loginAdmin } from "helpers/backend_helper";
import { useRequest } from "ahooks";
import { isValidEmail } from "helpers/helper";

import styles from "./index.module.css";

type FieldType = {
  email?: string;
  password?: string;
  remember?: boolean;
  firstName?: string;
  lastName?: string;
};

const LoginPage: React.FC = () => {
  const [form] = Form.useForm<FieldType>();
  const [error, setError] = useState("");
  const { loading, run: login } = useRequest(loginAdmin, {
    manual: true,
    onError: (error: any) => {
      setError(error.response?.data?.message || "wrong user name or password");
    },
    onSuccess: (data) => {
      if (data.access_token) {
        if (form.getFieldValue("remember")) {
          localStorage.setItem("accessToken", data.access_token);
        } else {
          sessionStorage.setItem("accessToken", data.access_token);
        }
        window.location.href = "/";
      }
    },
  });
  const onFinish: FormProps<FieldType>["onFinish"] = () => {
    setError("");
    login(form.getFieldValue("email"), form.getFieldValue("password"));
  };
  return (
    <div className={styles.container}>
      <Form
        form={form}
        name="basic"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        initialValues={{ remember: true, registration: false, email: "", password: "", firstName: "", lastName: "" }}
        style={{ width: 500 }}
        onFinish={onFinish}
        autoComplete="off"
      >
        <Form.Item
          rules={[
            {
              required: true,
              message: "invalid email",
            },
            () => ({
              validator(_, value) {
                if (!value || isValidEmail(value)) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error("invalid email"));
              },
            }),
          ]}
          label="Username"
          name="email"
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Password"
          name="password"
          rules={[{ required: true, message: "Please input your password!" }]}
        >
          <Input.Password />
        </Form.Item>
        <div className={styles.error}>
          <Form.ErrorList errors={[error]} />
        </div>
        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
          <Button type="primary" htmlType="submit" loading={loading}>
            Submit
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default LoginPage;
